<template>
  <IconLucideFolderInput />
</template>
